import DataMapper from './DataMapper'
import MedicRM from '../responsemodel/MedicRM'
import Medic from '../../models/Medic'

class MedicDataMapper extends DataMapper<MedicRM, Medic> {
  map = (rm: MedicRM) => new Medic(rm.id, rm.name, rm.qualification, rm.registration_number, rm.council_name, rm.lab_name, rm.verified, rm.role)
}

export default MedicDataMapper
